import { useEffect, useState } from "react"
import { getThemeById, postTheme, patchTheme } from "../../services/ThemeServices"
import { ThemeFormContext } from "./ThemeContext"
import { useNavigate, useParams } from 'react-router-dom';
//import { Color } from '../../routes/RoutesConstants'

export const ThemeFormState = ({ children }) => {
    const [report, setReport] = useState({})
    const navigate = useNavigate();
    const { id } = useParams()

    useEffect(() => {
        if (id) getThemeByIdData(id)
    }, [])

    const getThemeByIdData = async (id) => {
        let res = await getThemeById(id)
        if (res) setReport(res)
    }

    const postThemeData = async (body) => {
        const res = await postTheme(body)
        if (res) navigate("/theme");
    }

    const patchThemeData = async (id, body) => {
        const res = await patchTheme(id, body)

        if (res) navigate("/theme");
    }


    return <ThemeFormContext.Provider value={{
        report,
        postThemeData,
        patchThemeData,
    }} >
        {children}
    </ThemeFormContext.Provider>
}